module.exports = __webpack_public_path__ + "img/friends-logo2.f67cb451.png";